import { Routes } from '@angular/router';
import { Initial } from './pages/initial/initial';
import { Login } from './pages/login/login';
import { Home } from './pages/home/home';
import { Profile } from './pages/profile/profile';
import { EditProfile as MainEditProfile} from './pages/edit-profile/edit-profile';
import { Posts } from './pages/posts/posts';
import { Carnet } from './pages/ibero/carnet/carnet';
import { Notes } from './pages/ibero/notes/notes';
import { EditProfile as IberoEditProfile } from './pages/ibero/edit-profile/edit-profile';
import { Order } from './pages/ibero/order/order';
import { Schedule } from './pages/ibero/schedule/schedule';

export const routes: Routes = [
  // Rutas específicas primero
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: Home },
  { path: 'profile', component: Profile },
  { path: 'edit-profile', component: MainEditProfile },
  { path: 'posts', component: Posts },
  { path: 'posts/:id', component: Posts },
  
  // Ruta dinámica para Initial (debe estar al final)
  { path: ':id', component: Initial },
  
  // Redirect para rutas no encontradas
  { path: '**', redirectTo: 'home' }
];
